import { Button } from '@eo/shared';

type Props = {
  error?: boolean;
  onRetry?: () => void;
};

export function NotConfigured({ error = false, onRetry }: Props) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md rounded-16 border border-border-faint bg-[var(--color-canvas-base)] p-8 text-center">
        <h1 className="text-lg font-semibold text-text-primary">
          {error ? 'Something went wrong' : 'Account not configured'}
        </h1>
        <p className="mt-2 text-sm text-text-tertiary">
          {error
            ? 'Mission Control could not load your profile. Try again in a moment.'
            : 'You are signed in, but this account is not set up for Mission Control yet. Ask an admin to add you to the staff registry.'}
        </p>
        {error && onRetry && (
          <Button className="mt-4" onClick={onRetry}>
            Try again
          </Button>
        )}
      </div>
    </div>
  );
}
